import { apiCall } from '@/lib/api-client';
import type {
  AdminUser,
  AdminUsersFilters,
  AdminUsersPage,
  CreateUserInput,
  UpdateUserInput,
} from '@/types/api';

export const usersApi = {
  list: (filters: AdminUsersFilters, limit = 50, offset = 0) => {
    const p = new URLSearchParams();
    p.set('limit', String(limit));
    p.set('offset', String(offset));
    if (filters.role) p.set('role', filters.role);
    if (typeof filters.active === 'boolean') p.set('active', String(filters.active));
    if (filters.q) p.set('q', filters.q);
    return apiCall<AdminUsersPage>(`/admin/users?${p.toString()}`);
  },

  create: (input: CreateUserInput) =>
    apiCall<AdminUser>('/admin/users', { method: 'POST', body: input }),

  update: (id: string, input: UpdateUserInput) =>
    apiCall<AdminUser>(`/admin/users/${id}`, { method: 'PATCH', body: input }),

  resetPassword: (id: string, newPassword: string) =>
    apiCall<{ ok: true; mustChangePassword: true }>(
      `/admin/users/${id}/reset-password`,
      { method: 'POST', body: { newPassword } },
    ),
};
